import { getFileMime } from "/WebInterface/new-ui/modules/advanced-download/common.js";
import { downloadFilesContainer } from "/WebInterface/new-ui/modules/advanced-download/template.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import downloadingQueue from "/WebInterface/new-ui/modules/advanced-download/downloading-queue.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { showSaveFilePicker } from "/WebInterface/new-ui/assets/js/thirdparty/native-file-system-adapter-3.0.0/es6.js";

// export let advanceDownloads;
let dialog;

export const initAdvancedDownload = () => {
  dialog = new Modal({
    title: "Advanced Download",
    body: downloadFilesContainer({
      removeAllText: t("removeAll"),
    }),
    animate: false,
    show: false,
    backdrop: false,
    movable: true,
    closable: false,
    hasCloseOption: true,
    hasFooter: false,
    destroyOnClose: false,
    uniqueId: "UI_Download",
    extraClasses: ["files-to-download-modal"],
    minWidth: "860px",
    minHeight: "700px",
  });

  _$("#remove-all-button-advanced-download").on("click", () => {
    const downloadFiles = {};

    Object.values(store.downloadFilesDetails.files).forEach((file) => {
      const id = file?.id;

      if (
        file.status === "downloading" ||
        file.status === "pausing" ||
        file.status === "paused" ||
        file.status === "compressing" ||
        file.status === "sandboxDownloading"
      ) {
        downloadFiles[id] = file;
        return;
      }

      downloadingQueue?.remove(id, false);
    });

    store.dispatch("removeAllDownloadFiles", downloadFiles);
  });
};

export const showDownloadModal = () => {
  if (!dialog.visible()) {
    dialog.show(true);
  }
};

export const downloadFiles = async (
  files,
  downloadTypeByRangeCustomization
) => {
  const canUseWebSocketForDownloading = utils.getUserCustomizationValue(
    "useWSForAdvancedDownloads"
  );

  let downloadType, storageMethod;
  if (downloadTypeByRangeCustomization) {
    [downloadType, storageMethod] =
      downloadTypeByRangeCustomization?.split("|");
  }

  for (const file of files) {
    try {
      console.log(
        `Saving file: ${file.name} Download Type: ${downloadType} Storage Method: ${storageMethod}`
      );
      const fileHandle = await showSaveFilePicker({
        suggestedName: file.name,
        _preferPolyfill: storageMethod === "sandbox",
        excludeAcceptAllOption: true,
        types: [getFileMime(file.name)],
      });

      console.log(
        "File picker params" +
          {
            suggestedName: file.name,
            _preferPolyfill: storageMethod === "sandbox",
            excludeAcceptAllOption: true,
            types: [getFileMime(file.name)],
          }
      );

      const downloadTypeBySimpleCustomization = canUseWebSocketForDownloading
        ? "WS"
        : "Normal";

      const _file = {
        ...file,
        id: utils.getUId(),
        fileHandle,
        downloadType: downloadType || downloadTypeBySimpleCustomization || "WS",
        storageMethod,
        status: "queued",
        progressStatus: {
          bytesDownloaded: 0,
        },
        timeStatus: {
          speed: 0,
          elapsedTime: 0,
          avg10SecSpeed: 0,
        },
      };

      store.dispatch("setFilesInDownload", _file);
      downloadingQueue.addFileToQueue(_file);
      showDownloadModal();
    } catch (error) {
      console.log(error);
    }
  }
};

// Common methods
const updateDownloadFileProgressBar = ({ fileId, size, maxSize }) => {
  const fileCard = _$(`#${fileId}`).el();
  if (fileCard) {
    _$(fileCard).find(".progress").attr("value", size);
    _$(fileCard).find(".progress").attr("max", maxSize);

    const updatedValue = parseInt(size);

    const completedValue = utils.formatBytes(updatedValue);
    const maxValue = utils.formatBytes(maxSize);

    const percentage = Math.ceil((size / maxSize) * 100);

    _$(fileCard).find("#completed-percentage").text(`${percentage} %`);

    _$(fileCard)
      .find(".download-progress-status #fileSizeDownloaded")
      .text(`${completedValue}`);

    _$(fileCard)
      .find(".download-progress-status #fileSize")
      .text(`${maxValue}`);

    _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
    _$(fileCard).find(".progress-bar-container").removeClass("is-hidden");
  }
};

const updateGlobalProgressBar = (size) => {
  const downloadingFiles = downloadingQueue.getGlobalDownloadedFiles();
  const completedFiles = downloadingQueue.getCompletedFiles();

  let totalBytesToDownload = 0;
  let totalBytesDownloaded = Number(size);

  downloadingFiles.forEach((file) => {
    totalBytesToDownload += Number(file.size);
  });

  completedFiles.forEach((file) => {
    totalBytesDownloaded += Number(file.size);
  });

  updateDownloadFileProgressBar({
    fileId: "globalDownloads",
    size: totalBytesDownloaded,
    maxSize: totalBytesToDownload,
  });
};

// subscribe events
export const advancedDownloadSubscribeEvents = [
  {
    eventName: "updateProgressBarDownload,updateFileStatusDownloadDisk",
    callback: (action, payload) => {
      const onlyDiskUpdate = action === "updateFileStatusDownloadDisk";
      if (action === "updateFileStatusDownloadDisk") {
        console.log("Check here", payload);
      }
      const { fileId } = payload;

      const downloadingFileCard = _$(`#${fileId}`);
      if (!downloadingFileCard.el()) return;

      if (!onlyDiskUpdate) {
        const { bytesDownloaded, fileSize } = payload;
        const calculatePercentage = parseInt(
          (bytesDownloaded / fileSize) * 100
        );
        const downloadedBytesFormatted = utils.formatBytes(bytesDownloaded);

        const progressBarContainer = downloadingFileCard.find(
          ".progress-bar-container",
          true
        );

        const downloadedSizeFormatted = downloadingFileCard.find(
          ".fileSizeDownloaded",
          true
        );

        const progressBar = downloadingFileCard.find(
          ".progress-bar-container .progress",
          true
        );

        const progressPercentage = downloadingFileCard.find(
          ".completed-percentage",
          true
        );

        progressPercentage.innerText = `${calculatePercentage}%`;
        downloadedSizeFormatted.innerText = `${downloadedBytesFormatted}`;

        progressBar.setAttribute("value", bytesDownloaded);
        progressBar.setAttribute("max", fileSize);
        progressBarContainer.classList.remove("is-hidden");
        progressPercentage.classList.remove("is-hidden");
        updateGlobalProgressBar(bytesDownloaded);
      } else {
        const { bytesWritten, fileSize } = payload;
        const diskWriteInfo = downloadingFileCard.find(
          ".disk-write-info",
          true
        );

        if (bytesWritten) {
          const progressBarContainerDisk = downloadingFileCard.find(
            ".disk-progress-container",
            true
          );
          const progressBarDisk = downloadingFileCard.find(
            ".disk-progress-container .progress",
            true
          );

          const progressPercentageDisk = downloadingFileCard.find(
            ".disk-completed-percentage",
            true
          );

          const calculatePercentageDisk = parseInt(
            (bytesWritten / fileSize) * 100
          );
          const downloadedBytesFormattedDisk = utils.formatBytes(bytesWritten);

          diskWriteInfo.classList.remove("is-hidden");
          progressBarDisk.setAttribute("value", bytesWritten);
          progressBarDisk.setAttribute("max", fileSize);
          progressPercentageDisk.innerText = `${calculatePercentageDisk}% ${downloadedBytesFormattedDisk}`;
        } else {
          diskWriteInfo.classList.add("is-hidden");
        }
      }
    },
  },
  {
    eventName: "updateTimeStatusDownload",
    callback: (action, payload) => {
      const { fileId, speed, elapsedTime, timeRemaining, bytesWritten } =
        payload;

      const fileCard = _$(`#${fileId}`).el();
      if (!fileCard) return;

      const downloadingSpeed = utils.formatBytes(speed);
      const _elapsedTime = utils.formatTime({
        secs: elapsedTime,
        minLabel: "m",
        secondsLabel: "s",
      });
      const _timeRemaining = timeRemaining
        ? utils.formatTime({
            secs: timeRemaining,
            minLabel: "m",
            secondsLabel: "s",
          })
        : "-";

      _$(fileCard)
        .find(".download-progress-status .downloadingSpeed")
        .text(`${downloadingSpeed}/s`);

      _$(fileCard)
        .find(".download-progress-status .elapsedTime")
        .text(`${_elapsedTime}`);

      _$(fileCard)
        .find(".download-progress-status .remainingTime")
        .html(`${_timeRemaining}`);

      _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
      if (bytesWritten) {
        const realSpeed = bytesWritten / elapsedTime;
        const diskCompletedSpeed = utils.formatBytes(realSpeed);
        _$(fileCard)
          .find(".disk-completed-speed")
          .text(`${diskCompletedSpeed}/s`);
      }
      store.dispatch("updateGlobalDownloadTime");
    },
  },
  {
    eventName: "updateTenSecondAverageDownload",
    callback: (action, payload) => {
      const { fileId, speed } = payload;

      const fileCard = _$(`#${fileId}`).el();
      if (!fileCard) return;

      const downloadingAvg10SecSpeed = utils.formatBytes(speed);

      _$(fileCard)
        .find(".download-progress-status .downloadingAvg10SecSpeed")
        .text(`${downloadingAvg10SecSpeed}/s`);

      _$(fileCard).find(".download-progress-status").removeClass("is-hidden");
    },
  },
];
